import { z } from 'zod';

/** AppleRetail.Web.ApiControllers.AppleRetailBulkOrderApiController.BulkOrder */
export const cartResponseSchema = z.object({
	bulkOrderId: z.string(),
});
